import React, { createContext, useMemo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { listRequests, listMessages } from 'services/api'
import { appProfileSelector } from 'redux/selectors';
import PropTypes from 'prop-types';

export const ConversationContext = createContext();
export const ConversationProvider = ({ children }) => {
    const profile = useSelector(appProfileSelector);
    const [channels, setChannels] = useState([])
    const [conversation, setConversation] = useState(null);
    const [messages, setMessages] = useState([]);
    const [refresh, setRefresh] = useState(new Date());


    useEffect(() => {
        if (profile) {
            loadChannels()
        }
    }, [profile])

    useEffect(() => {
        loadMessages()
    }, [conversation])


    const loadChannels = () => {
        listRequests({}).then(res => {
            if (res.code == 200) {
                setChannels(res.data)
            }
        })
    }
    const loadMessages = () => {
        if (conversation) {
            listMessages({ requestId: conversation.id }).then(res => {
                if (res.code == 200) {
                    setMessages(res.data.reverse())
                }
            })
        }
    }
    const value = useMemo(() => ({
        loadChannels,
        channels,
        conversation,
        setConversation,
        loadMessages,
        messages,
        refresh,
        setRefresh
    }), [
        loadChannels,
        channels,
        conversation,
        setConversation,
        loadMessages,
        messages,
        refresh,
        setRefresh
    ]);
    return (
        <ConversationContext.Provider
            value={value}
        >
            {children}
        </ConversationContext.Provider>
    );
};
ConversationProvider.propTypes = {
    children: PropTypes.any
};
